"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Label = exports.BaseLabel = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _style = _interopRequireDefault(require("./style"));

var _ThemeProvider = require("../ThemeProvider");

var BaseLabel = function BaseLabel(_ref) {
  var displayValue = _ref.displayValue,
      getFormValue = _ref.getFormValue,
      name = _ref.name,
      classes = _ref.classes,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? 'label' : _ref$id;
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "".concat(id, "/label/").concat(name),
    className: classes.Label
  }, displayValue ? displayValue : getFormValue(name));
};

exports.BaseLabel = BaseLabel;
BaseLabel.propTypes = {
  getFormValue: _propTypes["default"].func,
  displayValue: _propTypes["default"].string,
  name: _propTypes["default"].string,
  classes: _propTypes["default"].object,
  id: _propTypes["default"].string
};
var Label = (0, _ThemeProvider.withStyles)(_style["default"])(BaseLabel);
exports["default"] = exports.Label = Label;
//# sourceMappingURL=Label.js.map